import { BoneSide } from "@project-rouge/rg-core";
function getInnerLoadSide(bFacesA, start, right) {
	if (bFacesA) {
		if (right && start) return BoneSide.Right;
		else if (right && !start) return BoneSide.Left;
		else if (!right && start) return BoneSide.Left;
		else if (!right && !start) return BoneSide.Right;
	} else if (right && start) return BoneSide.Left;
	else if (right && !start) return BoneSide.Right;
	else if (!right && start) return BoneSide.Right;
	else if (!right && !start) return BoneSide.Left;
	throw new Error("unreachable code");
}
export { getInnerLoadSide };

//# sourceMappingURL=index18.js.map